import PropTypes from 'prop-types';
import React from 'react';
import {
  Panel,
  PanelHeader,
  Space,
  Close,
} from 'rebass';

import LoginPanel from './Login';
import RegisterPanel from './Register';
import ForgotPasswordPanel from './ForgotPassword';

class AuthPanel extends React.Component {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,

    onRegister: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
  };

  state = {
    view: 'login',
  };

  changeView = (view) => {
    this.setState({ view });
  };

  render() {
    const { onRequestClose, onRegister, onLogin } = this.props;
    let component;
    let title;
    switch (this.state.view) {
      case 'register':
        title = 'Create Account';
        component = (
          <RegisterPanel
            onSuccess={onRegister}
            onViewLoginClick={() => this.changeView('login')}
          />
        );
        break;
      case 'forgot':
        title = 'Forgot Password';
        component = (
          <ForgotPasswordPanel
            onViewLoginClick={() => this.changeView('login')}
          />
        );
        break;
      case 'login':
      default:
        title = 'Login';
        component = (
          <LoginPanel
            onSuccess={onLogin}

            onViewRegisterClick={() => this.changeView('register')}
            onViewForgotClick={() => this.changeView('forgot')}
          />
        );
        break;
    }
    return (
      <Panel theme="primary">
        <PanelHeader>
          {title}
          <Space auto />
          <Close onClick={onRequestClose} />
        </PanelHeader>
        {component}
      </Panel>
    );
  }
}

export default AuthPanel;
